export default "__VITE_ASSET__kU9izZnq__"